import React from "react";
import TableList from "./tableList";

const PricingIndex: React.FC = () => {

  return (
    <div>
      <TableList />
    </div>
  );
};

export default PricingIndex;